// legacy vars - TODO need cleanup
export const gasLimitFallback = '4500000'
